module.exports = __webpack_public_path__ + "static/media/rentime-logo.e890eaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rentime-logo.png
// module id = 875
// module chunks = 0